<template>
  <div class="infonews">
    <div class="info">
      <div class="itemtop">
        <h3>信息公开</h3>
        <router-link :to="`/news/views/${plateIdInfo}`">更多</router-link>
      </div>
      <div class="itembottom">
        <div class="item">
          <span v-for="(item,index) in INFO_LIST" :class="{ first: index === 0, active: activeInfoIndex === index}"
            :key="index" v-text="item" @click="changeInfo(0, index, item)">
          </span>
        </div>
        <ul class="itemlist">
          <li v-for="item in infos" :key="item.id">
            <i></i>
            <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" :title="item.title">{{ item.title}}
            </router-link>
            <span>{{ item.addtime | datefilter }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="news">
      <div class="itemtop">
        <h3>新闻动态</h3>
        <router-link :to="`/news/views/${plateIdNews}`">更多</router-link>
      </div>
      <ul class="itembottom">
        <div class="item">
          <span v-for="(item,index) in NEWS_LIST" :class="{ first: index === 0, active: activeNewsIndex === index}"
            :key="index" v-text="item" @click="changeInfo(1, index, item)">
          </span>
        </div>
        <ul class=" itemlist">
          <li v-for="item in news" :key="item.id">
            <i></i>
            <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" :title="item.title">{{ item.title}}
            </router-link>
            <span>{{ item.addtime | datefilter }}</span>
          </li>
        </ul>
      </ul>
    </div>
  </div>
</template>

<script>
import { getFindcategory } from '@/request/get'
import { INFO_NEWS,INFO_LIST, NEWS_LIST } from '@/config'
export default {
  name: "InfoNews",
  components: {
  },
  data() {
    return {
      activeInfoIndex: 0,
      activeNewsIndex: 0,
      INFO_NEWS: INFO_NEWS,
      INFO_LIST: INFO_LIST,
      NEWS_LIST: NEWS_LIST,
      infos: [],
      news: [],
      dataSource: [],
      plateIdInfo: "",
      plateIdNews: ""
    }
  },
  filters: {
    datefilter(value) {
      return value.slice(5, -8);
    }
  },
  created() {
    this.INFO_NEWS.forEach((value,index) => {
      this.getFindcategory(index, value);
    });
    
  },
  mounted() {
  },
  methods: {
    async getFindcategory(index,value) {
      let { plates } = this.$store.state;
      let list = plates.filter((item) => value == item.name);
      let uuid = list[0].uuid;
      let name;
      if (index === 0) {
        name = this.INFO_LIST[0];
        this.plateIdInfo = uuid;
      } else {
        name = this.NEWS_LIST[0];
        this.plateIdNews = uuid;
      }
      let result = await getFindcategory(uuid);
      this.dataSource[index] = result.data;
      this.changeInfo(index, 0, name);
    },
    changeInfo(indexs, index,name) {
      if (indexs === 0) {
        this.activeInfoIndex = index;
        let infos = this.dataSource[indexs].filter(item => item.CategoryChild.name === name);//匹配栏目名
        this.infos = infos[0].rows;
      } else {
        this.activeNewsIndex = index;
        let news = this.dataSource[indexs].filter(item => item.CategoryChild.name === name);//匹配栏目名
        this.news = news[0].rows;
      }
      
    }
  }
};
</script>
<style scoped>
.infonews{
  position: relative;
  margin:44px 0 34px 0;
  width: 1200px;
  height: 481px;
  display: flex;
  justify-content: space-between;
}
.infonews>.info,.infonews>.news{
  width: 579px;
  height: 100%;
  font-family: PingFang SC;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.infonews>.info>.itemtop,.infonews>.news>.itemtop{
  width: 579px;
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.infonews>.info>.itemtop {
  background: url(/static/img/icon_xinxi.png) no-repeat 6px 0px;
}
.infonews>.news>.itemtop {
  background: url(/static/img/icon_xinwen.png) no-repeat 6px 0px;
}
.infonews>.info>.itemtop>h3,.infonews>.news>.itemtop>h3 {
  padding-left: 57px;
  width: 111px;
  height: 38px;
  font-size: 26px;
  font-weight: bold;
  color: #333333;
  line-height: 38px;
}
.infonews>.info>.itemtop>a,.infonews>.news>.itemtop>a{
  width: 64px;
  height: 38px;
  font-size: 16px;
  font-weight: 500;
  color: #1759A1;
  line-height: 38px;
  background: url(/static/img/gengduo.png) no-repeat center right;
  background-size: 24px 13px;
}
.infonews>.info>.itembottom,.infonews>.news>.itembottom {
  width: 577px;
  height: 421px;
  border-top: 4px solid #2479D3;
  border-left: 1px solid #E0E0E0;
  border-right: 1px solid #E0E0E0;
  border-bottom: 1px solid #E0E0E0;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.infonews>.info>.itembottom>.item,.infonews>.news>.itembottom>.item{
  width: 566px;
  padding-left: 11px;
  height: 65px;
  background: #F7F7F8;
  border-bottom: 1px solid #E0E0E0;
  display: flex;
  justify-content: start;
}
.infonews>.info>.itembottom>.item>span,.infonews>.news>.itembottom>.item>span {
  height: 64px;
  margin: 0 40px;
  font-size: 22px;
  font-weight: bold;
  color: #666666;
  line-height: 65px;
}
.infonews>.info>.itembottom>.item>span.active,.infonews>.news>.itembottom>.item>span.active {
  color: #2479D3;
  border-bottom: 3px solid #2479D3;
}
.infonews>.info>.itembottom>.item>span.first,.infonews>.news>.itembottom>.item>span.first {
  margin-left: 0;
}
.infonews>.info>.itembottom>.itemlist,.infonews>.news>.itembottom>.itemlist{
  width: 546px;
  height: 280px;
  padding: 40px 20px 35px 10px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  overflow: hidden;
}
.infonews>.info>.itembottom>.itemlist>li,.infonews>.news>.itembottom>.itemlist>li {
  height: 20px;
  margin-bottom:24.5px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.infonews>.info>.itembottom>.itemlist>li>i,.infonews>.news>.itembottom>.itemlist>li>i{
  width: 8px;
  height: 8px;
  background: #BFBFBF;
  border-radius: 4px;
  margin-right: 17px;
}
.infonews>.info>.itembottom>.itemlist>li>a,.infonews>.news>.itembottom>.itemlist>li>a {
  width: 358px;
  height: 20px;
  margin-right: 114px;
  font-size: 16px;
  letter-spacing: 1px;
  font-weight: 500;
  color: #666666;
  line-height: 20px;
  overflow: hidden;
}
.infonews>.info>.itembottom>.itemlist>li>span,.infonews>.news>.itembottom>.itemlist>li>span{
  width: 51px;
  height: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #999999;
  line-height: 20px;
}
</style>
